import { DATE_RANGES } from 'features/admin/lib/metrics';

import React, {useEffect} from 'react';
import {useForm} from 'react-hook-form';

import DateRangePickerControlled from 'shared/ui/Date/DateRangePickerControlled/DateRangePickerControlled';

import styles from './DateRangePicker.module.scss';

interface DateRangePickerProps {
    // eslint-disable-next-line no-unused-vars
    onRangeChange: (range: string) => void;
    customRange?: { start: Date; end: Date };
    // eslint-disable-next-line no-unused-vars
    onCustomRangeChange: (range: { start: Date; end: Date }) => void;
    // eslint-disable-next-line react/no-unused-prop-types
    currentRange: string;
}

interface DateRangeForm {
    dateRange: [Date, Date];
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({
    onRangeChange,
    customRange,
    onCustomRangeChange,
}) => {
    const { control, setValue } = useForm<DateRangeForm>();

    useEffect(() => {
        if (customRange && customRange.start && customRange.end) {
            setValue('dateRange', [customRange.start, customRange.end]);
        }
    }, [customRange, setValue]);

    const handleDateRangeChange = (value: [Date, Date] | null) => {
        if (value && value[0] && value[1]) {
            onCustomRangeChange({
                start: value[0],
                end: value[1],
            });
            onRangeChange('custom');
        }
    };

    const handlePresetRangeChange = (range: string) => {
        onRangeChange(range);
    };

    return (
        <div className={styles.dateControls}>
            <span className={styles.title}>Выбор периода:</span>
            <div className={styles.rangeButtons}>
                {DATE_RANGES.map(range => (
                    <button
                        key={range.id}
                        onClick={() => handlePresetRangeChange(range.id)}
                        className={styles.button}
                    >
                        {range.label}
                    </button>
                ))}
            </div>
            <DateRangePickerControlled
                control={control}
                name="dateRange"
                onChange={handleDateRangeChange}
                cleanable={true}
            />
        </div>
    );
};

export default DateRangePicker;